<template>
  <div>
    <div class="page">
      <!-- 头部 -->
      <div class="head">
        <div class="head_logo">
          <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/logo.png" alt="" />
          <p>高慧智能</p>
        </div>
        <div class="hear_right">
          <img
            v-if="disp == false"
            @click="open"
            src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/cd.png"
            alt=""
          />
          <img
            v-if="disp == true"
            @click="close"
            src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/cd.png"
            alt=""
          />
        </div>
        <!-- 弹出层 -->
        <div v-if="disp" class="popups">
          <div
            :class="names == 'home' ? 'optFor' : ''"
            @click="home"
            class="popups_title"
          >
            <p>首页</p>
            <!-- <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/esc.png" alt="" /> -->
          </div>
          <div
            :class="names == 'introx' ? 'optFor' : ''"
            @click="introx"
            class="introx"
          >
            <p>企业简介</p>
          </div>
          <div
            :class="names == 'vision' ? 'optFor' : ''"
            @click="vision"
            class="vision"
          >
            <p>企业愿景</p>
          </div>
          <div
            :class="names == 'businessService' ? 'optFor' : ''"
            @click="businessService"
            class="businessService"
          >
            <p>业务服务</p>
          </div>
          <div
            :class="names == 'contactUs' ? 'optFor' : ''"
            @click="contactUs"
            class="contactUs"
          >
            <p>联系我们</p>
          </div>
        </div>
      </div>
      <!-- 轮播图 -->
      <div class="page_swiper"></div>
      <!-- 企业简介 -->
      <div class="intro">
        <div class="intro_title">
          <p>企业简介</p>
          <div class="adorn"></div>
        </div>
        <p class="intro_titlex">ENTERPRISE BRIEF INTRODUCTION</p>
        <div class="intro_cont">
          <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/qyjj_1661762060.jpg" alt="" />
          <p>
            西安高慧智能科技有限公司，专注于精准医疗和AI制药领域，发力”分子医学高性能计算服务”和”分子医学大数据服务，通过高性能计算服务和人工智能大数据服务，精准提升医疗管理、疾病预防、医学研究、药品研发等的智慧化水平，为国家医学分子中心、地区龙头医院提供一站式大数据平台建设。
          </p>
        </div>
      </div>
      <!-- 立志成为一只健康医疗大数据服务中心 -->
      <div class="picture"></div>
      <!-- 业务服务 -->
      <div class="business_service">
        <div class="intro_titles">
          <p>业务服务</p>
          <div class="adornx"></div>
        </div>
        <p class="intro_titlex">THE ENTERPRISE SERVICE</p>
        <div class="business_service_One">
          <div class="one_left">
            <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/gxnjsfw.png" alt="" />
          </div>
          <div class="one_right">
            <p class="one_right_title">业务服务</p>
            <p class="one_right_cont">实现在最短时间内完成最大量的计算任务。</p>
          </div>
        </div>
        <div class="business_service_two">
          <div class="two_left">
            <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/fzyxglpt.png" alt="" />
          </div>
          <div class="two_right">
            <p class="two_right_title">分子医学大数据管理平台</p>
            <p class="two_right_cont">
              核心是阐明人类疾病在分子和细胞水平上的病理、生理机制，并将有关成果转化为临床预测、诊断、预防和治疗的有效手段代表着当代生命科学发展趋势。
            </p>
          </div>
        </div>
        <div class="business_service_three">
          <div class="three_left">
            <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/jzyl.png" alt="" />
          </div>
          <div class="three_right">
            <p class="three_right_title">精准医疗</p>
            <p class="three_right_cont">
              实现医源性损害最小化医疗耗费最低化以及病患获益最大化。
            </p>
          </div>
        </div>
        <div class="business_service_four">
          <div class="four_left">
            <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/ai.png" alt="" />
          </div>
          <div class="four_right">
            <p class="four_right_title">分子医学大数据管理平台</p>
            <p class="four_right_cont">
              以医药大数据为学习研究土壤运用NLP、CV、知识图谱机器学习、深度学习等AI技术参与制药过程,以计算、预测、寻找合适的新兴的有机物化学反应、潜在药物分子并观察药物临床效果的技术手段。
            </p>
          </div>
        </div>
      </div>
      <!-- 超算平台 -->
      <div class="platform">
        <div class="intro_titler">
          <p>超算平台</p>
          <div class="adornr"></div>
        </div>
        <p class="platform_cont">
          依托国家分子医学超算中心以立足西安、辐射全国、构建国内领先、国际一流的信息化基础设施及公共服务平台为总目标，面向医学科学计算、生物医药、人工智能等重点行业应用领域，随需提供超级云计算服务，支撑医学研究领域的产业升级与科技创新，助力国家医学科技发展
        </p>
        <div class="cspt">
          <img class="cspt" src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/cspt_1661762386.jpg" alt="" />
        </div>
      </div>
      <!-- 分子医学管理平台 -->
      <div class="platform">
        <div class="intro_titler">
          <p>分子医学管理平台</p>
          <div class="adornrs"></div>
        </div>
        <p class="platform_cont">
          支持分子医学领域相关科研工作的开展、包含有常用的管理功能、分别为动物类、细胞类、人类基本信息数据收集分析、整理、统一管理、采用高效云存储、安全高效保证数据高度安全。
          可采用通用分析流程直接使用超算平台算力进行科研分析。也可采取自定义流程、自由组合分析流程、满足特定科研需求。
        </p>
        <div class="cspt">
          <img class="cspt" src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/111213123_1661762134.jpg" alt="" />
        </div>
      </div>
      <!-- 底部内容 -->
      <div class="bottom">
        <div class="bottom_cont">
          <div class="bottom_logo">
            <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/bottomLogo.png" alt="" />
            <p>高慧智能</p>
          </div>
          <div class="phone">
            <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/phone.png" alt="" />
            <p>400-188-1961</p>
          </div>
          <div class="site">
            <img src="https://gao-hui.oss-cn-beijing.aliyuncs.com/images/site.png" alt="" />
            <p>陕西省西安市新城区金花北路恒基碧翠锦华31栋1-1502</p>
          </div>
        </div>
        <div class="icp">
          <p>陕ICP备2022008765号</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disp: false,
      names: "home",
    };
  },
  methods: {
    open() {
      this.disp = true;
    },
    close() {
      console.log();
      this.disp = false;
    },
    // 首页
    home() {
      document.documentElement.scrollTop = 0;
      this.names = "home";
        this.disp = false;
    },
    // 企业简介
    introx() {
      document.documentElement.scrollTop = 165;
      this.names = "introx";
        this.disp = false;
    },
    // 企业愿景
    vision() {
      this.names = "vision";
      document.documentElement.scrollTop = 530;
        this.disp = false;
    },
    // 业务服务
    businessService() {
      this.names = "businessService";
      document.documentElement.scrollTop = 657;
        this.disp = false;
    },
    // 联系我们
    contactUs() {
      this.names = "contactUs";
      document.documentElement.scrollTop = 1438;
        this.disp = false;
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //   console.log(scrollTop, "滚动距离");
      if (scrollTop > 0) {
        this.names = "home";
        if (scrollTop >= 165) {
          this.names = "introx";
          if (scrollTop >= 530) {
            this.names = "vision";
            if (scrollTop >= 657) {
              this.names = "businessService";
              if (scrollTop >= 1438) {
                this.names = "contactUs";
              }
            }
          }
        }
      }
    },
  },
  mounted: function () {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.handleScroll, false); // 监听（绑定）滚轮滚动事件
  },
};
</script>

<style scoped>
.head {
  width: 100%;
  height: 54px;
  padding-top: 10px;
  background-color: #fff;
  display: flex;
  line-height: 50px;
  margin-top: 5px;
  justify-content: space-between;
  position: fixed;
  top: -5px;
  z-index: 200;
}
.head_logo {
  margin-left: 15px;
  display: flex;
}
.head_logo p {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2753a2;
  margin-left: 15px;
}
.head_logo img {
  width: 40px;
  height: 44px;
}
.hear_right img {
  width: 17px;
  height: 17px;
  margin-right: 15px;
}
.page_swiper {
  width: 100%;
  height: 170px;
  margin-top: 50px;
  background-image: url("https://gao-hui.oss-cn-beijing.aliyuncs.com/images/swiper_1661762023.jpg");
  background-size: 100% 100%;
}
.intro {
  /* top: 20px; */
  position: relative;
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.intro_title p {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2d3035;
  /* z-index: 20; */
}
.adorn {
  position: absolute;
  width: 65px;
  height: 8px;
  top: 13px;
  /* z-index: 2; */
  background: linear-gradient(180deg, rgba(34, 138, 211, 0) 0%, #0f52a8 100%);
}
.intro_titlex {
  margin-top: 15px;
  font-size: 12px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #cbcbcb;
  line-height: 18px;
}
.intro_cont {
  display: flex;
  flex-direction: column;
}
.intro_cont p {
  width: 345px;
  height: 85px;
  /* margin-top: 19px; */
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #2c3035;
  line-height: 17px;
}
.intro_cont img {
  width: 242px;
  height: 147px;
  margin: 20px auto;
}
.picture {
  height: 122px;
  background-image: url("https://gao-hui.oss-cn-beijing.aliyuncs.com/images/lzcw_1661762081.jpg");
  background-size: 100% 100%;
}
.business_service_One {
  display: flex;
  width: 100%;
  background-color: #f6fafd;
  height: 77px;
  margin-top: 10px;
}
.one_left img {
  width: 44px;
  height: 41px;
  margin: 18px 26px 18px 15px;
}
.one_right_title {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #0f52a8;
}
.one_right {
  margin-top: 15px;
}
.one_right_cont {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 10px;
}
.business_service_two {
  display: flex;
  width: 100%;
  margin-top: 10px;
  background-color: #f6fafd;
  height: 122px;
}
.two_left img {
  width: 44px;
  height: 41px;
  margin: 40px 26px 18px 15px;
}
.two_right_title {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #0f52a8;
}
.two_right {
  margin-top: 15px;
}
.two_right_cont {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 10px;
  width: 251px;
  height: 68px;
}
.business_service_three {
  display: flex;
  margin-top: 10px;
  width: 100%;
  background-color: #f6fafd;
  height: 94px;
}
.three_left img {
  width: 44px;
  height: 41px;
  margin: 26px 26px 18px 15px;
}
.three_right_title {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #0f52a8;
}
.three_right {
  margin-top: 15px;
}
.three_right_cont {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 10px;
  width: 251px;
  height: 68px;
}
.business_service_four {
  display: flex;
  width: 100%;
  background-color: #f6fafd;
  height: 138px;
  margin-top: 10px;
}
.four_left img {
  width: 44px;
  height: 41px;
  margin: 44px 26px 18px 15px;
}
.four_right_title {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #0f52a8;
}
.four_right {
  margin-top: 15px;
}
.four_right_cont {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 10px;
  width: 275px;
  height: 68px;
}
.intro_titles {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2d3035;
  /* z-index: 20; */
}
.adornx {
  position: absolute;
  width: 65px;
  height: 8px;
  top: 13px;
  /* z-index: 2; */
  background: linear-gradient(180deg, rgba(34, 138, 211, 0) 0%, #0f52a8 100%);
}
.business_service {
  position: relative;
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.platform {
  position: relative;
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.intro_titler {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2d3035;
  /* z-index: 20; */
}
.adornr {
  position: absolute;
  width: 65px;
  height: 8px;
  top: 13px;
  /* z-index: 2; */
  background: linear-gradient(180deg, rgba(34, 138, 211, 0) 0%, #0f52a8 100%);
}
.platform_cont {
  margin: 15px;
  width: 345px;
  height: 85px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #2c3035;
  line-height: 17px;
}
.cspt {
  width: 345px;
  height: 178px;
  border: 1px solid #000;
}
.adornrs {
  position: absolute;
  width: 128px;
  height: 8px;
  top: 13px;
  /* z-index: 2; */
  background: linear-gradient(180deg, rgba(34, 138, 211, 0) 0%, #0f52a8 100%);
}
.bottom {
  width: 100%;
  height: 141px;
  background: #03385e;
  padding-top: 15px;
}
.bottom_logo {
  display: flex;
  height: 27px;
  margin-left: 5px;
  line-height: 27px;
}
.bottom_logo img {
  width: 25px;
  height: 27px;
}
.bottom_logo p {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  /* font-weight: 500; */
  color: #ffffff;
  margin-left: 15px;
}
.phone {
  display: flex;
  height: 17px;
  line-height: 17px;
  margin-left: 5px;
  margin-top: 12px;
}
.phone p {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-left: 5px;
}
.phone img {
  width: 13px;
  height: 13px;
}
.site {
  display: flex;
  height: 17px;
  line-height: 17px;
  margin-top: 11px;
  margin-left: 5px;
  padding-bottom: 13px;
}
.site p {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-left: 5px;
}
.bottom_cont {
  margin-left: 20px;
  width: 345px;
  border-bottom: 1px solid #fff;
  /* margin-top: 15px; */
}
.site img {
  width: 13px;
  height: 13px;
}
.icp {
  position: absolute;
  right: 25px;
  margin-top: 10px;
  /* display: flex;
  justify-content: right;
  margin-top: 10px;
  margin-right: 25px; */
}
.icp p {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.popups {
  position: absolute;
  right: 0;
  /* right: 10px; */
  top: 35px;
  width: 123px;
  height: 204px;
  background: #fff;
  border-radius: 5px 0px 0px 5px;
  z-index: 300;
}
.popups_title {
  height: 35px;
  width: 95%;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  /* font-weight: 400; */
  color: #2c3035;
  line-height: 20px;
  display: flex;
  margin: 0 auto;
  border-bottom: 1px solid #eeebee;
  /* margin: 10px 45px; */
  /* justify-content: space-between; */
}
.popups_title p {
  margin-left: 46px;
  margin-top: 10px;
}
.popups_title img {
  width: 12px;
  height: 12px;
  margin-top: 10px;
  margin-left: 24px;
  /* margin: 3px 24px; */
}
.introx {
  margin: 0 auto;
  width: 113px;
  height: 40px;
  border-bottom: 1px solid #eeebee;
  text-align: center;
  line-height: 40px;
  /* opacity: 0.1; */
}
.vision {
  margin: 0 auto;
  width: 113px;
  height: 40px;
  border-bottom: 1px solid #eeebee;
  text-align: center;
  line-height: 40px;
}
.businessService {
  margin: 0 auto;
  width: 113px;
  height: 40px;
  border-bottom: 1px solid #eeebee;
  text-align: center;
  line-height: 40px;
}
.contactUs {
  margin: 0 auto;
  width: 113px;
  height: 40px;
  border-bottom: 1px solid #eeebee;
  text-align: center;
  line-height: 40px;
}
.optFor {
  background: rgba(39, 82, 161, 0.1);
}
</style>